
const setMasterDashBoardDateRange = async (dateRange) => {
    return dateRange;
}

const invoiceService = {
    setMasterDashBoardDateRange,
}

export default invoiceService;